/* Black Month · Code kopieren und direkt im Warenkorb aktivieren (snippets/miz-promo.liquid) */
(function () {
  if (window.mizPromoReady) return;
  window.mizPromoReady = true;

  var STORE_KEY = 'mizPromoApplied';

  function storedCode() {
    try {
      return sessionStorage.getItem(STORE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function rememberCode(code) {
    try {
      sessionStorage.setItem(STORE_KEY, code.toUpperCase());
    } catch (e) {}
  }

  // In-App-Browser (z. B. Instagram) sperren die Zwischenablage teils; dann der ältere Weg
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return copyFallback(text);
      });
    }
    return copyFallback(text);
  }

  function copyFallback(text) {
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy') ? resolve() : reject(new Error('copy'));
      } catch (e) {
        reject(e);
      } finally {
        area.remove();
      }
    });
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Code am Warenkorb hinterlegen; Shopify zieht ihn für alle passenden Artikel ab
  function applyCode(code, sections) {
    var body = { discount: code };
    if (sections) body.sections = sections;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('cart ' + res.status);
      return res.json();
    });
  }

  function syncApplied() {
    var code = storedCode();
    if (!code) return;
    document.querySelectorAll('.miz-promo--pdp[data-miz-promo]').forEach(function (box) {
      if (box.getAttribute('data-miz-promo').toUpperCase() === code) box.setAttribute('data-applied', '');
    });
  }

  document.addEventListener('click', function (event) {
    var copyBtn = event.target.closest('[data-miz-promo-copy]');
    if (copyBtn) {
      var label = copyBtn.querySelector('[data-miz-promo-label]');
      var original = label ? label.getAttribute('data-original') || label.textContent : '';
      if (label) label.setAttribute('data-original', original);
      copyText(copyBtn.getAttribute('data-miz-promo-copy'))
        .then(function () {
          if (!label) return;
          label.textContent = copyBtn.getAttribute('data-copied');
          clearTimeout(copyBtn._mizTimer);
          copyBtn._mizTimer = setTimeout(function () {
            label.textContent = original;
          }, 1800);
        })
        .catch(function () {});
      return;
    }

    var activateBtn = event.target.closest('[data-miz-promo-activate]');
    if (!activateBtn) return;
    var box = activateBtn.closest('.miz-promo');
    var error = box && box.querySelector('[data-miz-promo-error]');
    var code = activateBtn.getAttribute('data-miz-promo-activate');
    var refresh = activateBtn.hasAttribute('data-miz-promo-refresh');
    var drawer = activateBtn.closest('cart-drawer');
    activateBtn.disabled = true;
    if (error) error.hidden = true;

    applyCode(code, drawer ? ['cart-drawer', 'cart-icon-bubble'] : null)
      .then(function (cart) {
        rememberCode(code);
        if (drawer && cart.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(cart);
        } else if (refresh) {
          window.location.reload();
        } else if (box) {
          box.setAttribute('data-applied', '');
          var done = box.querySelector('[data-miz-promo-done]');
          if (done) {
            done.setAttribute('tabindex', '-1');
            done.focus({ preventScroll: true });
          }
        }
      })
      .catch(function () {
        activateBtn.disabled = false;
        if (error) error.hidden = false;
      });
  });

  function init() {
    syncApplied();
    // Variantenwechsel: Box mit dem Preis der neuen Variante übernehmen
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.html || !data.sectionId) return;
        var id = 'MizPromo-' + data.sectionId;
        var current = document.getElementById(id);
        var next = data.html.getElementById(id);
        if (current && next) {
          current.innerHTML = next.innerHTML;
          syncApplied();
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
